import React, { useContext, useEffect, useState } from 'react';
import axios from 'axios';
import { AuthContext } from '../App';
import { platformName } from '../lib/site';

// Shown when the API answers 402 subscription_required (trial ended / plan canceled). Customers' public links are unaffected.
export default function SubscriptionGate() {
  const { logout } = useContext(AuthContext);
  const [st, setSt] = useState(null);
  useEffect(() => { axios.get('/billing/status').then((r) => setSt(r.data)).catch(() => setSt({})); }, []);
  const sub = st?.subscription;
  return (
    <div data-testid="subscription-gate" style={{ minHeight: '100vh', background: '#0B1120', color: '#E2E8F0', display: 'grid', placeItems: 'center', padding: 24, fontFamily: 'Inter, system-ui, sans-serif' }}>
      <div style={{ maxWidth: 760, width: '100%' }}>
        <p style={{ fontWeight: 800, fontSize: 20 }}>{platformName()}</p>
        <h1 style={{ fontSize: 30, fontWeight: 800, margin: '8px 0' }}>{sub?.status === 'expired' ? 'Your free trial has ended' : 'Your subscription needs attention'}</h1>
        <p style={{ color: '#94A3B8' }} data-testid="gate-message">
          {st?.company_name ? `${st.company_name}'s workspace is paused` : 'Your workspace is paused'} — your data, customers and proposals are safe and your customers' payment & approval links keep working.
          {' '}Online subscription payments are not yet active, so nothing has been charged. To continue, contact {st?.support_email ? <a href={`mailto:${st.support_email}`} style={{ color: '#A5B4FC' }}>{st.support_email}</a> : 'support'} and we'll activate your plan and send an invoice.
        </p>
        <div style={{ display: 'grid', gap: 12, gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', margin: '24px 0' }}>
          {(st?.plans || []).map((p) => (
            <div key={p.id} data-testid={`gate-plan-${p.id}`} style={{ background: '#111827', border: `1px solid ${sub?.plan === p.id ? '#6366F1' : '#1F2937'}`, borderRadius: 14, padding: 18 }}>
              <div style={{ fontWeight: 800 }}>{p.name}</div><div style={{ fontSize: 24, fontWeight: 800, margin: '6px 0' }}>${p.price_monthly}<span style={{ fontSize: 12, color: '#94A3B8' }}>/mo</span></div>
              <ul style={{ paddingLeft: 16, margin: 0, fontSize: 13, color: '#94A3B8' }}>{p.features.slice(0, 4).map((f) => <li key={f}>{f}</li>)}</ul>
            </div>
          ))}
        </div>
        <button data-testid="gate-logout-btn" onClick={logout} style={{ background: 'transparent', border: '1px solid #334155', color: '#CBD5E1', padding: '10px 16px', borderRadius: 10, cursor: 'pointer' }}>Sign out</button>
      </div>
    </div>
  );
}
